import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobalsLocal
import com.varabyte.kobweb.navigation.RoutePrefix
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.silk.defer.renderWithDeferred
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main(): Unit {
    RoutePrefix.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { io.zsoft.pages.HomePage() }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.initSilkHook = { ctx ->
        ctx.theme.registerComponentStyle(io.zsoft.styles.NavigationItemStyle)
        ctx.theme.registerComponentStyle(io.zsoft.styles.LogoStyle)
        ctx.theme.registerComponentStyle(io.zsoft.styles.SocialLinkStyle)
        ctx.theme.registerComponentStyle(io.zsoft.styles.MainButtonStyle)
        ctx.theme.registerComponentStyle(io.zsoft.styles.MainImageStyle)
        ctx.theme.registerComponentStyle(io.zsoft.styles.AboutImageStyle)
        ctx.theme.registerComponentStyle(io.zsoft.styles.AboutTextStyle)
        ctx.theme.registerComponentStyle(io.zsoft.styles.BackToTopButtonStyle)
        ctx.theme.registerComponentStyle(io.zsoft.styles.ServiceCardStyle)
        ctx.theme.registerComponentStyle(io.zsoft.styles.PortfolioSectionStyle)
        ctx.theme.registerComponentStyle(io.zsoft.styles.PortfolioArrowIconStyle)
        ctx.theme.registerComponentStyle(io.zsoft.styles.InputStyle)
        io.zsoft.updateTheme(ctx)
    }

    router.navigateTo(window.location.href.removePrefix(window.location.origin),
            UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will overwrite them
    // the first time we render this page with their composable, dynamic versions. Think of this as
    // poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("root")!!
    while (root.firstChild != null) {
        root.removeChild(root.firstChild!!)
    }

    renderComposable(rootElementId = "root") {
        CompositionLocalProvider(
            AppGlobalsLocal provides mapOf("title" to "zsoft Landing Page")
        ) { io.zsoft.MyApp {
              router.renderActivePage { renderWithDeferred { it() } }
        } }
    }
}
